import { environment, release, sentryDSN } from '@/configuration'
import type { Pinia } from 'pinia'
import type { App } from 'vue'
import type { Router } from 'vue-router'

export async function configureSentry({
  pinia,
  router,
  app,
}: {
  pinia: Pinia
  router: Router
  app: App
}) {
  if (!sentryDSN) return

  const Sentry = await import('@sentry/vue')
  pinia.use(Sentry.createSentryPiniaPlugin())
  Sentry.init({
    dsn: sentryDSN,
    app,
    release,
    environment,
    integrations: [Sentry.browserTracingIntegration({ router })],
  })
}
